import LectureFrom from './LectureForm'

export default LectureFrom
